import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { APP_SETTINGS } from '@services';
import { Subscription } from 'rxjs';
import { HandleError } from '../../core/models/handle-error';
import { AnalyticsService } from '../../core/services/analytics/analytics.service';
import { AuthService } from '../../core/services/auth/auth.service';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { UtilityService } from '../../core/services/utility/utility.service';
import { UserProfileService } from '../user-profile/user-profile.service';
import { OperatingFluidsService } from './operating-fluids.service';
import { NgIf, NgClass, NgStyle, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SearchFilterPipe } from '../../shared/pipes/search-filter.pipe';
import { BrandTypePipe } from '../../shared/pipes/brand-type.pipe';

@Component({
    selector: 'app-operating-fluids',
    templateUrl: './operating-fluids.component.html',
    styleUrls: ['./operating-fluids.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        NgClass,
        NgStyle,
        FormsModule,
        NgFor,
        SearchFilterPipe,
        BrandTypePipe,
    ],
})
export class OperatingFluidsComponent implements OnInit, OnDestroy {

  public screenWidth: number;
  private subscriptions: Subscription[];
  public isShowAll = false;
  public isShowNew = false;
  public isShowHistory = false;
  public operatingFluidDocs: any;
  APP_SETTINGS: any;
  public newDocsCount: number;
  public serviceError = 'Loading data. Please wait...';
  public search4bulletins;
  private username: string;
  errorMessage: string;

  constructor(
    private utilityService: UtilityService,
    private operatingFluidService: OperatingFluidsService,
    private changeDetector: ChangeDetectorRef,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService,
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.username = this.authService.getUserName();
    this.subscriptions = [];
    this.operatingFluidDocs = [];
    this.APP_SETTINGS = APP_SETTINGS;
    APP_SETTINGS.currentPage = 'operating-fluids'
    if (APP_SETTINGS.operatingFluids == 'all') { this.showAll(); }
    if (APP_SETTINGS.operatingFluids == 'new') { this.showNew(); }
    if (APP_SETTINGS.operatingFluids == 'history') { this.showHistory(); }
  }


  showAll() {
    this.isShowAll = true;
    this.isShowNew = false;
    this.isShowHistory = false;
    this.errorMessage = '';
    APP_SETTINGS.operatingFluids = 'all';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.operatingFluidService.getAllOperatingFluidManuals().subscribe(data => {
      this.operatingFluidDocs = data['content'];
      this.newDocsCount = data['newSize'];
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showNew() {
    this.isShowAll = false;
    this.isShowNew = true;
    this.errorMessage = '';
    this.isShowHistory = false;
    APP_SETTINGS.operatingFluids = 'new';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.operatingFluidService.getNewOperatingFluidManuals().subscribe(data => {
      this.operatingFluidDocs = data;
      if (this.operatingFluidDocs.length === 0) {
        this.errorMessage = 'No New Operating Fluid Documents Found';
      }
      this.newDocsCount = this.operatingFluidDocs.length;
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }
  showHistory() {
    this.isShowAll = false;
    this.isShowNew = false;
    this.isShowHistory = true;
    this.errorMessage = '';
    APP_SETTINGS.operatingFluids = 'history';
    this.spinnerService.show('bmwSpinner');
    this.subscriptions.push(this.operatingFluidService.getUserOperatingFluidHistory(this.username).subscribe(data => {
      this.operatingFluidDocs = data;
      if (this.operatingFluidDocs.length === 0) {
        this.errorMessage = 'No History Found';
      }
      this.spinnerService.hide('bmwSpinner');
    },
      error => {
        this.spinnerService.hide('bmwSpinner');
        this.serviceError = HandleError.handleAPIError(error);
      }
    ));
  }

  saveToHistory(isSaved, docId, documentNumber, documentTitle) {
    if (!isSaved) {
      this.subscriptions.push(this.operatingFluidService.addManualToUserHistory(this.username, docId).subscribe(value => {
        if (value) {
        }
      }));
    }

    //Analytics Call
    if (APP_SETTINGS.isAdmin === 'true') {
      this.analyticsService.trackClicksbyAdminUser('Operating Fluids', documentTitle, this.username);
    }
    else {
      this.analyticsService.trackClicksByDocumentsContentTypeLineMake('Operating Fluids', documentTitle);
    }
    if (APP_SETTINGS.isExternal === 'true') {
      this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
        this.analyticsService.trackClicksByExternalContentType('Operating Fluids', documentTitle, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
      });
    }
    if (APP_SETTINGS.isDealer === 'true') {
      this.analyticsService.trackDealerContentTypeLocation('Operating Fluids', documentTitle, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
        APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
    }
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

}
